module.exports = __webpack_public_path__ + "img/item9-2.1d27bcf8.jpeg";